import React from "react";
import ReportsTable from "./reportsTable";
import ProtectedContent from "../../../components/protectedContent";

const ReportsTab = () => {
  return (
    <ProtectedContent perms={["view_report"]} showFallback>
      <ReportsTable />
    </ProtectedContent>
  );
};

export default ReportsTab;
